import { Member } from 'modules/common/interfaces/member';

export enum BankAccountAutoClassify {
    Business = 'BUSINESS',
    NotBusiness = 'NOT_BUSINESS',
}

export enum BankAccountSubType {
    Checking = 'CHECKING',
    Savings = 'SAVINGS',
    Hsa = 'HSA',
    Cd = 'CD',
    MoneyMarket = 'MONEY_MARKET',
    CreditCard = 'CREDIT_CARD',
    Paypal = 'PAYPAL',
    Prepaid = 'PREPAID',
    CashManagement = 'CASH_MANAGEMENT',
    Ebt = 'EBT',
}

export enum BankAccountStatus {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
    Deleted = 'DELETED',
}

export interface BankAccount {
    id: number;
    status: BankAccountStatus;
    apiName: 'PLAID';
    apiAccountId: string;
    apiAccountName: string;
    apiAccountNo: string;
    apiInstitutionId: string;
    autoClassify: BankAccountAutoClassify;
    apiAccountType: 'DEPOSITORY' | 'CREDIT';
    apiSubType: BankAccountSubType;
    apiOfficialName: string;
    defaultClientId: number;
    syncTransactions: boolean;
    lastExpenseSyncedDate: string | null;
    lastRevenueSyncedDate: string | null;
}

export interface PlaidItem {
    id: Member['id'];
    status: 'ACTIVE' | 'INACTIVE' | 'DELETED';
    apiItemId: string;
    apiInstitutionId: string;
    apiInstitutionName: string;
    apiAccessToken: string;
    apiErrorType: string | null;
    apiErrorCode: string | null;
    apiErrorMessage: string | null;
    bank_accounts: BankAccount[];
    lastSyncedDate?: string;
    lastInstitutionTranDate?: string;
}

export type HurdlrPlaidItemsData = PlaidItem[];

export interface HurdlrPlaidItemsParams {
    memberId?: number;
    status?: BankAccountStatus;
    include_bank_accounts: boolean;
}
